import { useEffect } from 'react'
import { useRouter } from 'next/router'

const PREVIOUS_ROUTE_KEY = 'stn::previous::route'

export function useTrackPreviousRoute() {
  const router = useRouter()

  useEffect(() => {
    const handleRouteChangeStart = () => {
      const { pathname } = window.location
      const basePath = router.basePath ?? ''
      const normalized = basePath && pathname.startsWith(basePath) ? pathname.slice(basePath.length) || '/' : pathname
      sessionStorage.setItem(PREVIOUS_ROUTE_KEY, normalized)
    }

    router.events.on('routeChangeStart', handleRouteChangeStart)
    return () => router.events.off('routeChangeStart', handleRouteChangeStart)
  }, [router.events, router.basePath])
}

export function readPreviousRoute(): string {
  if (typeof window === 'undefined') return ''
  return sessionStorage.getItem(PREVIOUS_ROUTE_KEY) ?? ''
}
